<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
import { page } from '@/api/business/crmCustomerAccount'
import { getById } from '@/api/business/crmCustomer'
export default {
  components: {
    MSelectPulldown
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: false,
        page: 1,
        size: 10,
        total: 0
      }
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      this.$emit('change', checkedItem)
    },
    onItemClick(item) {
      this.$refs.pulldown.onItemChecked(item)
    },
    loadData() {
      return new Promise((resolve, reject) => {
        const params = {
          ...this.queryParams,
          page: 1,
          size: 99
        }
        page(params).then(res => {
          resolve({
            data: res.data.records
          })
          this.page.total = res.data.total
          if (!this.value && this.page.total === 1) {
            this.onItemChecked(res.data.records[0])
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    labelFn(item) {
      if (!item || !item.bankBranch) {
        return ''
      }
      return item.bankBranch + ' ' + (item.bankAccount || '')
    },
    async onAddBank() {
      try {
        const { data } = await getById(this.queryParams.customerId)
        let customerTypeAlias = 'kehu'
        if (this.$enums.CUSTOMER_TYPE.CUSTOMER.value === data.customerType){
          customerTypeAlias = 'kehu'
        } else if (this.$enums.CUSTOMER_TYPE.SUPPLIER.value === data.customerType){
          customerTypeAlias = 'supplier'
        } else if (this.$enums.CUSTOMER_TYPE.OUR_COMPANY.value === data.customerType){
          customerTypeAlias = 'ourCompany'
        }
        this.$openNewWindow(this.$router, {
          path: `/business/crmCustomer/${customerTypeAlias}/edit/${this.queryParams.customerId}`
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :page="page"
    :field="{ value: 'id', labelFn: labelFn }"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item padding-sm cursor"
        :class="{
          'active': item.id === localValue
        }"
        @click="onItemClick(item)"
      >
        <div class="flex justify-between">
          <div>
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.accountName }}</span>
          </div>
          <div>
            <span class="label">所属银行：</span>
            <span>{{ item.bankName || '-' }}</span>
          </div>
        </div>
        <div class="flex justify-between margin-top-sm">
          <div>
            <span class="label">银行账号：</span>
            <span>{{ item.bankAccount }}</span>
          </div>
          <div>
            <span class="label">开户行：</span>
            <span>{{ item.bankBranch || '-' }}</span>
          </div>
        </div>
      </div>
      <div class="margin-top-sm border-top text-center">
        <el-link type="primary" @click="onAddBank">新增银行账号</el-link>
      </div>
    </template>
    <template #empty>
      <div style="width: 100%;" class="text-center">
        <el-link type="primary" @click="onAddBank">新增银行账号</el-link>
      </div>
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
  .item {
    background: var(--color-fill-2);
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    &.active::after {
      content: '';
      position: absolute;
      top: -1em;
      left: -1em;
      width: 2em;
      height: 2em;
      transform: rotate(45deg);
      background: var(--color-success);
    }
    &.active::before {
      /* content: '◉'; */
      position: absolute;
      top: 0.2em;
      left: 0.2em;
      color: var(--color-white);
      z-index: 1;
    }

    & ~ & {
      margin-top: 12px;
    }
  }
  .label {
    font-size: 12px;
    color: var(--color-text-3);
  }
</style>
